import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Card,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel,
    TextField,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import Services from 'src/services/Services';

export default function BolParaEsnafApplications() {
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    const token = parsedUser.token
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [responses, setResponses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        Services.BolParaAboutToken(token)
            .then((res) => {
                if (res.data.status) getResponses(res.data.result.easypointID);
            })
            .catch(console.error);
    }, [token]);

    const getResponses = (poiID) => {
        Services.GetBolParaResponsesWithPoi(token, poiID)
            .then((res) => {
                setResponses(res.data.status ? res.data.result : []);
                setIsLoading(false);
            })
            .catch(console.error);
    };

    const handleSort = (key) => {
        const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
    };

    const sortedFilteredData = responses
        .filter((data) => data.companyTitle.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => {
            if (!sortConfig.key) return 0;
            const aVal = a[sortConfig.key];
            const bVal = b[sortConfig.key];
            if (typeof aVal === 'string') return sortConfig.direction === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
            return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
        });

    const getStatusLabel = (status) =>
        ({ '1': 'Satış Tamamlandı', '2': 'Satış İptal', '3': 'Onay Bekliyor', '4': 'Satış İptal Eski Üye' }[status] || 'Bilinmiyor');

    const formatTimestamp = (ts) => new Date(ts * 1000).toLocaleDateString('tr-TR');

    const maskName = (name) => (name ? name[0] + '*'.repeat(name.length - 1) : '');

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Card sx={{ width: '100%', maxWidth: 900, p: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#494D59' }}>
                    Easy Point Bol Para - Başvurular
                </Typography>

                <TextField
                    fullWidth
                    placeholder="Marka Ara"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ mb: 2 }}
                />

                {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Box>
                ) : sortedFilteredData.length ? (
                    <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {[
                                        { label: 'Durum', key: 'status' },
                                        { label: 'Başvuru Kodu', key: 'campaignApplyCode' },
                                        { label: 'Başvuran K.', key: 'data[0].name' },
                                        { label: 'Kampanya Adı', key: 'campaignID' },
                                        { label: 'Marka Adı', key: 'companyTitle' },
                                        { label: 'Tarih', key: 'createdDateTime' },
                                    ].map(({ label, key }) => (
                                        <TableCell key={key}>
                                            <TableSortLabel
                                                active={sortConfig.key === key}
                                                direction={sortConfig.direction}
                                                onClick={() => handleSort(key)}
                                            >
                                                {label}
                                            </TableSortLabel>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sortedFilteredData.map((data) => (
                                    <TableRow key={data.id} hover>
                                        <TableCell>{getStatusLabel(data.status)}</TableCell>
                                        <TableCell>{data.campaignApplyCode}</TableCell>
                                        <TableCell>{`${maskName(data.data[0].name)} ${maskName(data.data[0].lastname)}`}</TableCell>
                                        <TableCell>{data.title}</TableCell>
                                        <TableCell>{data.companyTitle}</TableCell>
                                        <TableCell>{formatTimestamp(data.createdDateTime)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Typography align="center" sx={{ mt: 4 }}>
                        Mevcut başvuru bulunamadı.
                    </Typography>
                )}
            </Card>
        </Box>
    );
}
